<template>
    <div class="launch">
        <div class="live-container clearfix">
            <div class="live-main">
                <div class="live-main-left">
                    <div class="channel-top">
                        <div class="channel-name">{{channelInfo.title}}</div>
                        <div class="channel-num">频道号: {{channelInfo.channel_id}}</div>
                    </div>
                    <div class="channel-main">
                        <div class="channel-main-box">
                            <div style="width: 100%; height: 100%;" v-if="showAliPlayer">
                                <vue-aliplayer-v2 ref="VueAliplayerV2" :options="options" @ready="ready"/>
                            </div>
                            <el-image style="width: 100%;" fit="contain" :src="channelCover" v-if="!showAliPlayer"></el-image>
                        </div>
                    </div>
                </div>
                <div class="live-main-right">
                    <div class="close-alert" v-if="isWSClose">
                        <el-alert
                            title="聊天室已断开，正在尝试重新连接...."
                            type="error"
                            effect="dark"
                            center
                            :closable="false">
                        </el-alert>
                    </div>
                    <div class="close-alert" v-if="isWSError">
                        <el-alert
                            title="聊天室连接失败重连中...."
                            type="error"
                            effect="dark"
                            center
                            :closable="false">
                        </el-alert>
                    </div>
                    <div class="live-comment">
                        <div class="comment-top">
                            <div class="launch-tab">
                                <div class="launch-tab-item" :class="showComment?'tab-active':''" @click="switchTab('comment')">讨论区</div>
                                <div class="launch-tab-item" :class="showComment?'':'tab-active'" @click="switchTab('member')">成员（{{onlineCount}}）</div>
                            </div>
                        </div>
                        <div class="comment-main" ref="commentMain">
                            <div v-if="showComment">
                                <message-item
                                    v-for="(item, index) in messageList"
                                    :key="index"
                                    :messageItem="item"
                                    :selfId="userInfo.user_id"
                                />
                            </div>
                            <div v-if="!showComment" class="member-list">
                                <div class="member-item" v-for="(item,index) in memberList" :key="index">
                                    <div v-if="item.user_type == 'teacher'">
                                        <el-avatar class="member-avatar" size="large" :src="item.avatar" @error="() => true">
                                            <img src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" alt srcset>
                                        </el-avatar>
                                        <div class="member-info">
                                            <div class="member-name">{{item.username}}</div>
                                            <div class="member-role teacher-role" >讲师</div>
                                        </div>
                                    </div>
                                    <div v-if="item.user_type == 'student'">
                                        <el-avatar class="member-avatar" size="large" :src="item.avatar" @error="() => true">
                                            <img src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" alt srcset>
                                        </el-avatar>
                                        <div class="member-info">
                                            <div class="member-name">{{item.username}}</div>
                                            <div class="member-role">学生</div>
                                        </div>
                                        <div class="member-online is-online">在线中</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="comment-bottom">
                            <div class="comment-tools">
                                <span class="tool-item" @click="handleSilent"><i class="iconfont" :class="isSilent ? 'icon-icon_jinyan1' : 'icon-icon_fayan1'"></i></span>
                                <span class="tool-item" @click.stop="handleEmojiCom"><i class="iconfont icon-icon_biaoqing" :class="isSilent ? 'silent' : ''" ></i></span>
                            </div>
                            <transition name="fade">
                                <custom-emoji v-if="showEmojiCom" class="emoji-component" @addemoji="addEmoji" />
                            </transition>
                            <div class="comment-send">
                                <div class="comment-input">
                                    <el-input class="input-field" v-model="messageText" :placeholder="isSilent ? '直播间已禁言' : '请输入...'" :disabled="isSilent" @keyup.enter.native="sendMessage"/>
                                </div>
                                <el-button class="comment-btn" type="primary" @click.stop.prevent="sendMessage" :disabled="isSilent || !messageText">发送</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import watchApi from '@/api/watch'
import { forbiddenWords } from '@/api/launch/index'
import { createSocket, sendWSPush, sendPing, closeSocket } from '@/utils/websocket'
import { getAccountId, removeAccountId } from '@/utils/auth'
import MessageItem from '@/components/MessageItem'
import VueAliplayerV2 from 'vue-aliplayer-v2'
import CustomEmoji from '@/components/CustomEmoji'

export default {
    name: 'launch',
    data() {
        return {
            showComment: true,
            messageList: [],
            memberList: [],
            onlineCount: 0,
            channelInfo: {},
            userInfo: {},
            showAliPlayer: false,
            options: {
                'width': '100%',
                'height': '100%',
                'source': '',
                'autoplay': true,
                'isLive': true,
                'rePlay': false,
                'playsinline': true,
                'preload': true,
                'controlBarVisibility': 'hover',
                'useH5Prism': true,
                'flvFrameChasing': true,
                'skinLayout': [{
                    'name': 'bigPlayButton',
                    'align': 'blabs',
                    'x': 30,
                    'y': 80
                }, {
                    'name': 'errorDisplay',
                    'align': 'tlabs',
                    'x': 0,
                    'y': 0
                }, {
                    'name': 'infoDisplay'
                }, {
                    'name': 'controlBar',
                    'align': 'blabs',
                    'x': 0,
                    'y': 0,
                    'children': [{
                        'name': 'liveDisplay',
                        'align': 'tlabs',
                        'x': 15,
                        'y': 6
                    }, {
                        'name': 'fullScreenButton',
                        'align': 'tr',
                        'x': 10,
                        'y': 13
                    }, {
                        'name': 'volume',
                        'align': 'tr',
                        'x': 5,
                        'y': 10
                    }]
                }]
            },
            messageText: '',
            showEmojiCom: false,
            isWSClose: false,
            isWSError: false,
            isSilent: false,
            accountId: '',
            channelCover: 'https://live-oss.busionline.com/assets/images/avatars/png_weikaishi@2x.png'
        }
    },
    components: {
        VueAliplayerV2,
        MessageItem,
        CustomEmoji
    },
    watch: {
        messageList: {
            handler() {
                this.$nextTick(() => {
                    setTimeout(() => {
                        // 显示数据的最后一行
                        const lastItem = document.querySelector('.message-item:last-child')
                        lastItem && lastItem.scrollIntoView()
                    }, 0)
                })
            },
            deep: true,
            immediate: true
        }
    },
    created() {
        document.addEventListener('click', this.handlerShowEmoji)
        this.channelId = this.$route.query.channel_id
        this.getChannelDetail()
    },
    methods: {
        getsocketData(e) {
            let data = JSON.parse(e.detail.data)
            let socketData = data.data
            switch (socketData.event) {
                case 'init':
                    let _content = {
                        'event': 'join_channel',
                        'channel_id': this.channelId,
                        'user_id': this.userInfo.user_id,
                        'user_type': this.userInfo.user_type,
                        'username': this.userInfo.username,
                        'avatar': this.userInfo.avatar,
                        'content': '加入频道'
                    }
                    sendWSPush(_content)
                    sendPing(socketData.ping_interval)
                    this.isWSClose = false
                    this.isWSError = false
                    break
                case 'join_channel':
                    if (socketData.channel_id == this.channelId) {
                        this.messageList = socketData.comment_list
                        this.memberList = socketData.online_user_list
                        this.onlineCount = socketData.online_count
                    }
                    break
                case 'leaving_channel':
                    if (socketData.channel_id == this.channelId) {
                        this.onlineCount = socketData.online_count
                        for (var i in this.memberList) {
                            delete this.memberList[socketData.client_id]
                        }
                    }
                    break
                case 'chat_speak':
                    if (socketData.channel_id == this.channelId) {
                        this.messageList = [...this.messageList, socketData]
                    }
                    break
                case 'live_publish':
                    if (socketData.channel_id == this.channelId) {
                        this.showAliPlayer = true
                    }
                    break
                case 'chat_banned':
                    if (socketData.channel_id == this.channelId) {
                        this.showEmojiCom = false
                    }
                    break
                case 'live_publish_done':
                    if (socketData.channel_id == this.channelId) {
                        this.showAliPlayer = false
                        this.channelCover = 'https://live-oss.busionline.com/assets/images/avatars/png_yijieshu@2x.png'
                    }
                    break
                case 'force_leaving_channel':
                    if (socketData.channel_id == this.channelId && socketData.user_id == this.userInfo.user_id) {
                        window.removeEventListener('onmessageWS', this.getSocketData)
                        window.removeEventListener('oncloseWS', this.oncloseWS)
                        window.removeEventListener('onerrorWS', this.onerrorWS)
                        closeSocket()
                        this.isWSClose = false
                        this.isWSError = false
                        this.$confirm('已在其它地方登录！', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            closeOnClickModal: false,
                            showCancelButton: false,
                            showClose: false,
                            type: 'warning'
                        }).then(() => {
                            removeAccountId()
                            location.reload()
                        })
                    }
                    break
                default:
                    break
            }
        },
        addEmoji(emoji = '') {
            this.messageText += emoji
            this.showEmojiCom = false
        },
        // 点击表情选择表情
        handlerShowEmoji() {
            this.showEmojiCom = false
        },
        handleEmojiCom() {
            if (this.isSilent) return
            this.showEmojiCom = !this.showEmojiCom
        },
        sendMessage() {
            // 发送消息
            let _content = {
                'event': 'chat_speak',
                'channel_id': this.channelId,
                'user_id': this.userInfo.user_id,
                'user_type': this.userInfo.user_type,
                'username': this.userInfo.username,
                'avatar': this.userInfo.avatar,
                'content': this.messageText
            }
            this.messageText = ''
            sendWSPush(_content)
        },
        getAccountId() {
            this.accountId = getAccountId()
        },
        async getChannelDetail() {
            await this.getAccountId()
            watchApi.getChannelDetail(this.channelId, { role: 'teacher' }).then(res => {
                if (res.code === 0) {
                    let data = res.data
                    this.channelInfo = data
                    if (!this.accountId || (Array.isArray(data.watch_info) && this.accountId)) {
                        removeAccountId()
                        this.$router.push({
                            path: '/launch/login',
                            query: { channel_id: this.channelId }
                        })
                    } else {
                        this.userInfo = res.data.watch_info
                        if (res.data.is_silent == '0') {
                            this.isSilent = false
                        } else {
                            this.isSilent = true
                        }
                        this.options.source = res.data.flv_url
                        if (res.data.status == 1) {
                            this.showAliPlayer = true
                        } else if (res.data.status == 2) {
                            this.channelCover = 'https://live-oss.busionline.com/assets/images/avatars/png_yijieshu@2x.png'
                        }
                        this.$store.commit('getWs', res.data.watch_info.ws)
                        createSocket()
                        window.addEventListener('onmessageWS', e => {
                            this.getsocketData(e)
                        })
                        window.addEventListener('oncloseWS', () => {
                            this.oncloseWS()
                        })
                        window.addEventListener('onerrorWS', () => {
                            this.onerrorWS()
                        })
                    }
                }
            }).catch(res => {})
        },
        handleSilent() {
            forbiddenWords(this.channelId).then(res => {
                if (res.code === 0) {
                    this.isSilent = !this.isSilent
                    let _content = {
                        'event': 'chat_banned',
                        'msg_type': 'custom',
                        'channel_id': this.channelId,
                        'user_id': this.userInfo.user_id,
                        'user_type': this.userInfo.user_type,
                        'username': this.userInfo.username,
                        'avatar': this.userInfo.avatar,
                        'content': '全体禁言操作',
                        'is_silent': this.isSilent ? '1' : '0'
                    }
                    this.messageText = ''
                    sendWSPush(_content)
                }
            }).catch(res => {})
        },
        oncloseWS() {
            this.isWSClose = true
        },
        onerrorWS() {
            this.isWSError = true
        },
        switchTab(val) {
            if (val === 'comment') {
                this.showComment = true
                setTimeout(() => {
                    this.$refs.commentMain.scrollTop = this.$refs.commentMain.scrollHeight
                }, 10)
            } else {
                this.showComment = false
            }
        },
        ready() {
            this.$nextTick(() => {
                this.$refs.VueAliplayerV2.setVolume(0)
                this.$refs.VueAliplayerV2.play()
            })
        }
    },
    beforeDestroy() {
        location.reload()
    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";
  .launch{
    width: 100%;
    height: 100%;
    min-height: 45vw;
    min-width: 1000px;
    background: #000000;
    padding: 90px 0;
    box-sizing: border-box;
  }
  .live-container{
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 90%;
    overflow: hidden;
    .live-main{
      .live-main-left{
        width: 100%;
        padding-right: 360px;
        box-sizing: border-box;
        background: #ffffff;
        overflow: hidden;
        .channel-top{
          position: relative;
          width: 100%;
          height: 64px;
          font-size: 16px;
          line-height: 64px;
          padding: 0 24px;
          box-sizing: border-box;
          .channel-name{
            float: left;
            color: #333;
            width: 70%;
            font-size: 22px;
            font-weight: bold;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .channel-num{
            position: absolute;
            color: #666;
            right: 24px;
            top: 0;
          }
        }
        .channel-main{
          position: relative;
          width: 100%;
          height: 0;
          padding-bottom: 56.25%;
          box-sizing: border-box;
          background-color: #fff;
          overflow: hidden;
          .channel-main-box{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
          }
        }
      }
      .live-main-right{
        position: absolute;
        right: 0;
        top: 0;
        width: 360px;
        height: 0;
        padding-bottom: calc(56.25% - 138.5px);
        background-color: #f7f7f7;
        .close-alert{
            position: absolute;
            width: 100%;
            z-index: 1;
        }
        .live-comment{
          .comment-top{
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 64px;
            font-size: 22px;
            box-sizing: border-box;
            border-left: 1px solid #DCDFE6;
            .launch-tab{
              display: flex;
              height: 64px;
              background: #fff;
              font-size: 16px;
              color: #636363;
              line-height: 64px;
              justify-content: center;
              text-align: center;
              border-bottom: 1px solid #DCDFE6;
              .launch-tab-item{
                position: relative;
                flex: 1;
                cursor: pointer;
                &:hover{
                  color: #1678FF;
                }
                &.tab-active{
                  color: #1678FF;
                  &::after {
                      content: "";
                      position: absolute;
                      width: 100%;
                      height: 4px;
                      background-color: #1678FF;
                      bottom: 0;
                      left: 0;
                  }
                }
              }
            }
          }
          .comment-main{
            position: absolute;
            left: 0;
            top: 64px;
            bottom: 108px;
            width: 100%;
            padding: 26px 16px;
            overflow-y: auto;
            &::-webkit-scrollbar {
              color: transparent;
            }

            &::-webkit-scrollbar-button {
              color: transparent;
            }

            &::-webkit-scrollbar-thumb {
              color: transparent;
            }

            &::-webkit-scrollbar-track {
              color: transparent;
            }

            &::-webkit-scrollbar-track-piece {
              color: transparent;
            }

            &::-webkit-scrollbar-corner {
              color: transparent;
            }

            &::-webkit-resizer {
              color: transparent;
            }
            .member-list{
              .member-item{
                position: relative;
                width: 328px;
                margin-bottom: 32px;
                &:last-child{
                  margin-bottom: 0;
                }
                .member-avatar{
                  float: left;
                  width: 40px;
                  height: 40px;
                  border-radius: 50%;
                }
                .member-info{
                  overflow: hidden;
                  padding-left: 12px;
                  .member-name{
                    font-size: 16px;
                    line-height: 16px;
                    margin-bottom: 8px;
                  }
                  .member-role{
                    width: 48px;
                    background: #1678FF;
                    border-radius: 2px;
                    font-size: 12px;
                    line-height: 16px;
                    text-align: center;
                    color: #fff;
                    &.teacher-role{
                      background: #FF6A00;
                    }
                  }
                }
                .member-online{
                  position: absolute;
                  right: 0;
                  top: 0;
                  bottom: 0;
                  margin: auto;
                  width: 66px;
                  height: 24px;
                  border-radius: 12px;
                  line-height: 24px;
                  text-align: center;
                  font-size: 14px;
                  background: #909399;
                  border-radius: 12px;
                  color: rgba(255,255,255,0.6);
                  &.is-online{
                    background: #1DCA4A;
                    color: rgba(255,255,255,1);
                  }
                }
              }
            }
          }
          .comment-bottom{
            position: absolute;
            left: 0;
            bottom: 0;
            height: 108px;
            width: 100%;
            background: #ffffff;
            padding: 0 16px;
            box-sizing: border-box;
            border-top: 1px solid #e5e5e5;
            .comment-tools{
              padding: 10px 0;
              .tool-item{
                margin-right: 16px;
              }
              .iconfont{
                font-size: 26px;
                color: rgba(153,153,153,0.6);
                cursor: pointer;
                &.silent {
                    cursor: not-allowed;
                    &:hover{
                    color: #999;
                    }
                }
                &.icon-icon_jinyan1{
                    color: $bthTextDangerColor;
                    &:hover{
                        color: $bthTextDangerColor;
                    }
                }
                &:hover{
                  color: $primaryColor;
                }
              }
            }
            .comment-send{
              .comment-input{
                float: left;
                margin-right: 8px;
                .input-field{
                  width: 236px;
                  height: 48px;
                  background: #FFFFFF;
                  border-radius: 4px;
                  ::v-deep .el-input__inner{
                    height: 48px;
                    line-height: 48px;
                    font-size: 14px;
                    color: #333333;
                  }
                }
              }
              .comment-btn{
                float: left;
                width: 84px;
                height: 48px;
                font-size: 18px;
              }
            }
          }
        }
      }
      .emoji-component {
        position: absolute;
        bottom: 98%;
        left: 11px;
        width: 338px;
      }
    }
  }
</style>
